import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Input} from '@angular/core';
import {Router} from '@angular/router';
import {UserService} from '../../Services/user.service';
import {ToolsBoxService} from '../../Services/tools.service';
import {User} from '../../Models/user.model';
import { NgClass } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DashboardComponent } from '../Dashboard/dashboard.component';
import { CalendarComponent } from '../CalendarComponent/calendar.component';

@Component({
    selector: 'overview',
    templateUrl: 'overview.component.html',
    styleUrls: ['overview.component.css'],
    imports: [NgClass, ReactiveFormsModule, FormsModule, DashboardComponent, CalendarComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewComponent implements OnInit {
  constructor(private userService: UserService, private toolsBoxService: ToolsBoxService, private router: Router, private cdr: ChangeDetectorRef) {
  }

  users: User[];
  selectedUser: User;
  @Input() displayedAsTab = false;

  displayDashboard = true;

  //Event label
  eventTypeLabels: any;

  ngOnInit() {
    this.toolsBoxService.tellChildContainsTabs(true);
    this.toolsBoxService.tellActionIsInProgress(true);
    this.eventTypeLabels = this.toolsBoxService.eventLabels;
    // console.log('Overview - onInit=> getUserList');
    this.userService.getUserList().subscribe(
      (list: User[]) => {
        this.users = list;
        if (this.users.length > 0)
          this.selectedUser = this.users[0];
        this.toolsBoxService.tellActionIsInProgress(false);
        this.cdr.markForCheck();
      },
      (err) => {
        this.toolsBoxService.tellActionIsInProgress(false);
        this.router.navigate(["Error", {errMessage: err.error}]);
      }
    );
  }
}
